module.exports = __webpack_public_path__ + "e7b60c9c2d3afca73ef77fc5371b3f53.svg";